<template>
  <div class="h-full">
    <div
      class="flex flex-col gap-2 h-full items-stretch rounded-xl p-7.5 md:mx-0"
      :style="{ backgroundColor: isHover ? `var(--${card.color})` : `var(--${cardBackground})` }"
      @mouseover="changeColorTheme"
      @mouseout="defaultColorTheme"
    >
      <div class="flex flex-col gap-7.5 h-full" :class="contentDisplay">
        <div class="flex items-center gap-5">
          <div
            v-if="card.symbol || card.id"
            class="flex justify-center items-center w-16 h-16 min-w-[64px] rounded-[18px]"
            :style="{ backgroundColor: isHover ? 'white' : `var(--${card.color})` }"
          >
            <div v-if="card.symbol">
              <Icon
                :key="`${card.title}-card`"
                :color="isHover ? card.color : 'white'"
                :icon="card.symbol"
                :class="[fluentCard, secureCard]"
              />
            </div>
            <div
              v-if="card.id"
              :key="id"
              class="font-semibold text-2xl"
              :style="{ color: isHover ? `var(--${card.color})` : 'white' }"
            >
              {{ card.id }}
            </div>
          </div>
          <div>
            <span v-if="card.status" class="text-red-700 text-lg font-semibold">
              {{ card.status }}
            </span>
            <h4 v-if="card.title" v-i18n="landingPage" :class="[cardTitleColor, cardTitleWidth]">
              {{ card.title }}
            </h4>
          </div>
        </div>
        <div class="flex h-full gap-2.5" :class="contentDisplay">
          <div
            v-if="Array.isArray(card.description)"
            class="text-[15px] p_base font-normal space-y-2"
            :class="isHover && 'text-white'"
          >
            <div
              v-for="(desc, index) in card.description"
              :key="index"
              class="flex items-start gap-2"
            >
              <Icon icon="star" :color="!isHover ? 'primary-purple-400' : 'white'" />
              <span v-i18n="landingPage" class="-mt-[5px]">{{ desc }}</span>
            </div>
          </div>
          <div
            v-else-if="typeof card.description === 'string'"
            class="text-[15px] p_base font-normal space-y-2"
            :class="isHover && 'text-white'"
          >
            <div class="flex items-start gap-2">
              <span v-i18n="landingPage" class="-mt-[5px]">{{ card.description }}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="card.routeName"
        class="mt-auto cursor-pointer flex items-center justify-end"
        @click="goToRoute(card.routeName)"
      >
        <Icon
          :key="`${card.title}-card`"
          :color="!isHover ? 'primary-purple-400' : 'white'"
          icon="circle-arrow"
          width="48"
          :class="[fluentCard, secureCard]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@src/components/icons/icon.vue'

export default {
  name: 'Card',
  components: {
    Icon,
  },
  props: {
    card: {
      type: Object,
      default: null,
    },
    id: {
      type: Number,
      default: 1,
    },
    beckground: { type: Boolean, default: false },
    contentDisplay: {
      type: String,
      default: '',
    },
    cardTitleWidth: {
      type: String,
      default: 'lg:max-w-[124px] xl:max-w-fit break-words',
    },
  },
  data() {
    return {
      landingPage: 'landingPage',
      isHover: false,
    }
  },
  computed: {
    cardTitleColor() {
      return this.isHover ? 'text-white' : 'text-text-primary-navy-blue '
    },
    cardBackground() {
      return this.beckground ? 'primary-purple-50' : 'white'
    },
  },

  methods: {
    changeColorTheme() {
      this.isHover = true
    },
    defaultColorTheme() {
      this.isHover = false
    },
    goToRoute(route) {
      const url = this.$router.resolve({ name: route }).href
      window.open(url, '_blank')
    },
  },
}
</script>
